export const FACE_INVENTORY_REQUEST = "FACE_INVENTORY_REQUEST";
export const FACE_INVENTORY_SUCCESS = "FACE_INVENTORY_SUCCESS";
export const FACE_INVENTORY_FAILED = "FACE_INVENTORY_FAILED";
export const FACE_HISTORY_REQUEST = "FACE_HISTORY_REQUEST";
export const FACE_HISTORY_SUCCESS = "FACE_HISTORY_SUCCESS";
export const FACE_HISTORY_FAILED = "FACE_HISTORY_FAILED";
